import { siteConfig } from '../data/config';
import { faqs } from '../data/faqs';
import type { Faq } from '../types/content';

export interface PriceDisplay {
  amount: string;
  currency: string;
}

export function getPrice(): PriceDisplay | null {
  const { price, currencyCode } = siteConfig;
  if (price === null || !currencyCode) return null;
  const amount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: Number.isInteger(price) ? 0 : 2,
  }).format(price);
  return { amount, currency: currencyCode.toUpperCase() };
}

/** Resolves FAQ answers; commercial questions are dropped until their terms are confirmed. */
export function publicFaqs(): Faq[] {
  return faqs.flatMap((f) => {
    if (f.commercial === 'delivery') {
      return siteConfig.deliveryDetails ? [{ ...f, answer: siteConfig.deliveryDetails }] : [];
    }
    if (f.commercial === 'payment') {
      const parts = [siteConfig.paymentTerms, siteConfig.guaranteeTerms].filter(Boolean);
      return parts.length ? [{ ...f, answer: parts.join(' ') }] : [];
    }
    return [f];
  });
}

export function missingLaunchInputs(): string[] {
  const c = siteConfig;
  const missing: string[] = [];
  if (!c.checkoutUrl) missing.push('Checkout URL — launch requirement. “Buy Diesel Fault Atlas” stays inactive until set.');
  if (c.price === null || !c.currencyCode) missing.push('Confirmed price and currency — launch requirement. Price is hidden until set.');
  if (!c.deliveryDetails) missing.push('Delivery details (FAQ “How will I receive it?” hidden)');
  if (!c.paymentTerms) missing.push('Payment terms');
  if (!c.guaranteeTerms) missing.push('Guarantee and refund terms (trust block and refund FAQ hidden)');
  if (!c.legalLinks.terms) missing.push('Terms & Conditions link');
  if (!c.legalLinks.privacy) missing.push('Privacy Policy link');
  if (!c.legalLinks.refund) missing.push('Refund Policy link');
  if (!c.legalLinks.contact) missing.push('Contact link');
  missing.push('Verified testimonials (section omitted until supplied)');
  missing.push('New-brand bonus imagery (bonuses shown as numbered entries)');
  return missing;
}
